import { useI18n } from '@ggs/i18n'
import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import { useCampusSessionForm } from '../../../local'
import { getDrupalSetting } from '@ggs/utils'
import './HomeCampusSessionForm.scss'

/**
 * @typedef {Object} SelectCampusSessionFormProps
 */

/**
 * Select UBC campus / session form.
 * @return {JSX.Element}
 */
export function HomeCampusSessionForm() {
  const { t } = useI18n()
  const baseUrl =
    getDrupalSetting('baseUrl') || `${process.env.REACT_APP_DRUPAL_BASE_URL}` || 'http://localhost'
  const isStorybook = `${process.env.STORYBOOK}` === 'yes'
  const browseCoursePath = '/browse-courses'

  /**
   * Redirect user to browse courses page.
   */
  const redirectToBrowseCourses = () => {
    const url = `${baseUrl}${browseCoursePath}`
    if (isStorybook) {
      alert(`User will be redirected to ${url} when executing in Drupal page`)
    } else {
      window.location.replace(url)
    }
  }

  /**
   * Handle navigate to browse courses.
   * @param {Object<string, any>} values
   * @param {any} formik
   * @return {Promise<void>}
   */
  const onSubmitHandler = async (values, { setSubmitting }) => {
    redirectToBrowseCourses()
    setSubmitting(false)
  }

  const { FormInstance, loading } = useCampusSessionForm({
    onSubmitHandler,
    actionLabel: t('View Courses'),
  })

  return (
    <Box className="select-campus-session">
      <Box className="select-campus-session__content">
        <Typography component="h2" className="select-campus-session__title">
          {t('Get Started')}
        </Typography>
        <Typography>
          {t('Using the drop-down boxes')}
          <strong>&nbsp;{t('select the campus and the academic period')}&nbsp;</strong>
          {t('for which you wish to view courses.')}
        </Typography>
      </Box>
      <Box className="select-campus-session__form-content">
        {loading ? (
          <Stack direction="row" alignItems="center" justifyContent="center">
            <CircularProgress size={24} />
            <Typography sx={{ ml: 2 }}>{t('Loading...')}</Typography>
          </Stack>
        ) : (
          FormInstance.FormComp
        )}
      </Box>
    </Box>
  )
}
